module.exports = __webpack_public_path__ + "media/3_6-10.b2c23cce.mp3";